/**
 * GA4 Configuration
 * Centralized configuration for GA4 tracking settings
 */

// Data Layer Configuration
export const GA4_CONFIG = {
  // Data layer key for GA4 events
  // Default: 'dataLayer2' for new GA4 container
  // Can be changed to 'dataLayer' to use existing container
  DATA_LAYER_KEY: process.env.NEXT_PUBLIC_GA4_DATA_LAYER_KEY || 'dataLayer',
  
  // GA4 Measurement ID
  // This should be updated with your actual GA4 property measurement ID
  MEASUREMENT_ID: process.env.GA_TRACKING_ID || 'GTM-NPQH7VV',
  
  // Currency code for e-commerce events
  CURRENCY: 'USD',

  // Debug mode (set to true for development)
  DEBUG: process.env.NODE_ENV === 'development',
  
  // Enable/disable GA4 tracking
  ENABLED: process.env.NEXT_PUBLIC_GA4_ENABLED !== 'false'
};

/**
 * Get the current data layer key
 * @returns {string} The data layer key
 */
export const getDataLayerKey = () => GA4_CONFIG.DATA_LAYER_KEY;

/**
 * Get the current GA4 measurement ID
 * @returns {string} The GA4 measurement ID
 */
export const getMeasurementId = () => GA4_CONFIG.MEASUREMENT_ID;

/**
 * Check if GA4 tracking is enabled
 * @returns {boolean} True if GA4 tracking is enabled
 */
export const isGA4Enabled = () => GA4_CONFIG.ENABLED;

/**
 * Check if debug mode is enabled
 * @returns {boolean} True if debug mode is enabled
 */
export const isDebugMode = () => GA4_CONFIG.DEBUG;

/**
 * Log debug information if debug mode is enabled
 * @param {string} message - Debug message
 * @param {any} data - Debug data
 */
export const debugLog = (message, data = null) => {
  if (isDebugMode()) {
    console.log(`[GA4 Debug] ${message}`, data);
  }
}; 